// @flow
'use strict';

import * as React from 'react';
import classnames from 'classnames';
import { Button } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import { formatoTela } from './formato_tela';

import ComTooltip from '../../common/com_tooltip';
import Icone from '../icone';

export type TipoFormatoTela =
    'botaoDetalhes'
    | 'data'
    | 'dataHora'
    | 'situacao'
    | 'modelo'
    | 'moeda'
    | 'percentual'
    | 'documento'
    | 'tributacao'
    | 'cep'
    | 'html';

type ColumnDetalhesProps<T> = {
  field : string,
  type? : TipoFormatoTela,
  align? : 'center' | 'left' | 'right',
  data? : T,
  width? : any,
  buttonClick? : (d : any) => void,
  className? : string,
  titleCelula? : bool,
  textoPreformatado? : bool,
  renderer? : (v : any, data : T) => React.Node,
  colSpan? : number,
  textoBotaoDetalhes? : string,
  botaoCopiar? : bool,
}

export default function ColumnDetalhes<T>({ field, type, align, data, buttonClick, className = '', titleCelula = false, textoPreformatado = false, renderer, colSpan = 1, textoBotaoDetalhes, botaoCopiar } : ColumnDetalhesProps<T>) {
  const handleClickData = data && field === 'cartao' && typeof data === 'object' ? data[field] : data;

  const handleClick = React.useCallback(() => buttonClick && buttonClick(handleClickData), [buttonClick, handleClickData]);

  const [copiado, setCopiado] = React.useState(false);

  if (type === 'botaoDetalhes' && buttonClick && handleClickData) {
    return (
        <td className="acoes">
          <Button bsSize="xs" bsStyle="default" onClick={ handleClick }>
            <Icone nome="search-plus" estilo="fas">{ textoBotaoDetalhes || 'detalhes' }</Icone>
          </Button>
        </td>
    );
  }

  let valor;

  if (type === 'html')
    valor = data && typeof data === 'object' ? <div dangerouslySetInnerHTML={{ __html: data[field] }}/> : '';
  else
    valor = data && typeof data === 'object' ? formatoTela(type, data[field]) : '';

  const configTitle = titleCelula ? { title: valor } : {};

  if (data && renderer)
    valor = renderer(valor, data);

  const apresentacaoValor = textoPreformatado && valor ? <pre>{ valor }</pre> : valor;

  let botaoCopia;

  if (botaoCopiar) {
    const mudarHintTrue = () => setCopiado(() => true);
    const mudarHintFalse = () => {
      setTimeout(() => {
        setCopiado(() => false);
      }, 100);
    };

    botaoCopia = <>&nbsp;&nbsp;<ComTooltip hint={ copiado ? 'Chave copiada!' : 'Copiar chave' } posicao="top">
      <CopyToClipboard text={ String(apresentacaoValor)?.replace(/\s+/g, '') || '' }>
        <span style={{ cursor: 'pointer' }} onClick={ mudarHintTrue } onPointerLeave={ mudarHintFalse }> <Icone nome="copy" estilo="far" /></span>
      </CopyToClipboard>
    </ComTooltip></>
  }

  return (
      <td className={ classnames(className, align && `text-${ align }`, 'quebra-de-linha') } { ...configTitle } colSpan={ colSpan }
          style={ textoPreformatado ? { borderTop: 'none', padding: 0 } : {} }>{ apresentacaoValor }{ botaoCopiar && apresentacaoValor !== '-' && botaoCopia }</td>
  );
}
